import { gql } from 'urql';

export const SECURITY_USERS_QUERY = gql`
  query SecurityUsers($search: String, $active: Boolean, $blocked: Boolean) {
    security_users(search: $search, active: $active, blocked: $blocked) {
      id
      email
      username
      nombre
      apellido
      activo
      bloqueado
      mustReset
      nivel
      legajo
      rolPrincipalId
      roles {
        id
        codigo
        nombre
        nivel
      }
      permisosEfectivos
      sucursalBaseId
      sucursalBase {
        id
        nombre
      }
      sucursalActivaId
      sucursalesHabilitadas {
        id
        nombre
      }
      ultimoLogin
    }
  }
`;

export const SECURITY_USER_DETAIL_QUERY = gql`
  query SecurityUserDetail($id: ID!, $effectiveSucursalId: ID) {
    security_user(id: $id) {
      id
      tenantId
      email
      username
      nombre
      apellido
      activo
      bloqueado
      mustReset
      observacionesInternas
      nivel
      allowWithoutEmployee
      empleadoId
      empleado {
        id
        legajo
        dni
        puesto
        email
        telefono
      }
      legajo
      rolPrincipalId
      roles {
        id
        codigo
        nombre
        descripcion
        nivel
        tipoRol
        scopeTipo
        activo
        permisos {
          id
          code
          name
          module
          action
          criticality
        }
      }
      permissionGrants {
        id
        code
        name
        module
        action
        criticality
      }
      permissionDenies {
        id
        code
        name
        module
        action
        criticality
      }
      permisosEfectivos
      permisosDenegados
      sucursalBaseId
      sucursalActivaId
      sucursalesHabilitadas {
        id
        nombre
        codigo
      }
      modulosVisibles
      ultimoLogin
      createdAt
      updatedAt
    }
    security_roles {
      id
      codigo
      nombre
      descripcion
      nivel
      tipoRol
      scopeTipo
      activo
      permisos {
        id
        code
        name
        module
        action
        criticality
      }
    }
    security_catalog {
      permissions {
        id
        code
        name
        description
        module
        group
        action
        criticality
        path
      }
    }
    security_empleados {
      id
      legajo
      nombre
      apellido
      dni
      email
      telefono
      puesto
      estado
    }
    security_sucursales {
      id
      nombre
      codigo
    }
    security_effective_permissions(userId: $id, sucursalActivaId: $effectiveSucursalId) {
      nivel
      permisosEfectivos
      permisosDenegados
      permisosOtorgadosManualmente
      sucursalesHabilitadas
      sucursalActiva
      modulosVisibles
      accionesPermitidas {
        code
        action
        module
        path
        criticality
      }
    }
  }
`;

export const SECURITY_USER_CREATE_QUERY = gql`
  query SecurityUserCreate {
    security_roles {
      id
      codigo
      nombre
      descripcion
      nivel
      tipoRol
      scopeTipo
      activo
      permisos {
        id
        code
        name
        module
        action
        criticality
      }
    }
    security_catalog {
      permissions {
        id
        code
        name
        description
        module
        group
        action
        criticality
        path
      }
    }
    security_empleados {
      id
      legajo
      nombre
      apellido
      dni
      email
      telefono
      puesto
      estado
    }
    security_sucursales {
      id
      nombre
      codigo
    }
  }
`;

export const SECURITY_USER_SAVE_MUTATION = gql`
  mutation SecurityUserSave($input: SecurityUserInput!) {
    security_user_save(input: $input) {
      id
      email
      nombre
      apellido
      activo
      bloqueado
      nivel
    }
  }
`;

export const SECURITY_USER_BLOCK_MUTATION = gql`
  mutation SecurityUserBlock($userId: ID!, $blocked: Boolean!) {
    security_user_block(userId: $userId, blocked: $blocked) {
      id
      activo
      bloqueado
    }
  }
`;

export const SECURITY_USER_TOGGLE_ACTIVE_MUTATION = gql`
  mutation SecurityUserToggleActive($userId: ID!, $active: Boolean!) {
    security_user_toggle_active(userId: $userId, active: $active) {
      id
      activo
      bloqueado
    }
  }
`;

export const SECURITY_USER_DELETE_MUTATION = gql`
  mutation SecurityUserDelete($userId: ID!) {
    security_user_delete(userId: $userId)
  }
`;

export const SECURITY_AUDIT_QUERY = gql`
  query SecurityAudit($entityType: String, $entityId: ID) {
    security_audit(entityType: $entityType, entityId: $entityId) {
      id
      entityType
      entityId
      actorUserId
      action
      diff
      createdAt
      sourceIp
      sourceAgent
    }
  }
`;
